export default function monthDiff(d: Date) {
    let m = d.getMonth();
    d.setMonth(d.getMonth() - 6);
    let diff = (m + 12 - d.getMonth()) % 12;
    if (diff < 6) d.setDate(0);

    return d;
}